module.exports = __webpack_public_path__ + "media/v2/components/shared/Image/medal-94e9fe8901cf1daf5cd608bfc721fd3a.svg";